import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import {
  BluePrintTicket,
  Ticket,
  TicketList,
  User,
  APIResponse,
  Pagination,
  TakeTicketLogData,
  SolveTicketLogData,
  EditProfileData,
  ChangeLabelLogData,
  ChangeDivisionLogData,
  AssignTicketLogData,
  LabelAssignLogData
} from '../models';

import { ApiService } from './api.service';

@Injectable()
export class TicketService {
  constructor(private http: Http, private apiService: ApiService) {}

  addTicket(ticket: BluePrintTicket): Observable<APIResponse<any, any>> {
    return this.apiService.post('/ticket/new', ticket);
  }

  generateTicketId(): Promise<string> {
    return this.apiService.getPromise('/ticket/generateid');
  }

  getMonitoredTickets(
    division: string,
    page: number
  ): Observable<APIResponse<Ticket[], any>> {
    return this.apiService.get('/tickets/monitor/' + division);
  }

  // get tickets assigned to current admin
  getMyTickets(
    division: any,
    role: string,
    skip: number,
    limit: number
  ): Observable<APIResponse<TicketList, any>> {
    return this.apiService.get(
      '/tickets/user/' + division + '/' + role + '/' + skip + '/' + limit
    );
  }

  // for All Tickets Menu
  getAllTickets(
    division: string,
    role: string,
    skip: number,
    limit: number
  ): Observable<APIResponse<TicketList, any>> {
    return this.apiService.get(
      '/tickets/all-tickets/' + division + '/' + role + '/' + skip + '/' + limit
    );
  }

  // for the Incoming Ticket Detail
  getSelectedTicket(id: string): Observable<APIResponse<Ticket, any>> {
    // let url = `${this.incomingTicketsUrl}/${id}`;
    return this.apiService.get('/ticket/detail/' + id);
  }

  // add label to ticket (1,2,3,4) and assign ticket
  setLabelAndAssign(
    updatedata:
      | ChangeLabelLogData
      | TakeTicketLogData
      | AssignTicketLogData
      | LabelAssignLogData
  ): Observable<APIResponse<Ticket, any>> {
    return this.apiService.post('/ticket/labelassign', updatedata);
  }

  // add division to ticket
  setTicketDivision(updatedata: ChangeDivisionLogData) {
    return this.apiService.put('/ticket/division', updatedata);
  }

  // reply ticket function
  replyTicket(
    updatedata: BluePrintTicket
  ): Observable<APIResponse<Ticket, any>> {
    return this.apiService.post('/ticket/reply', updatedata);
  }

  solveTicket(
    updatedata: SolveTicketLogData
  ): Observable<APIResponse<Ticket, any>> {
    console.log(updatedata);
    return this.apiService.post('/ticket/solve', updatedata);
  }
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/_shared/services/ticket.service.ts